module.exports = __webpack_public_path__ + "static/nandini-ad211511478bd420cf56af5a64a0c1d4.jpg";